import { useEffect, useState } from 'react'

import {
  activarAvisos,
  desactivarAvisos,
  estaInstalada,
  probarAviso,
  sePuedeAvisar,
  suscripcionActual,
} from '../api/avisos'

/**
 * Ajuste de los avisos de capitulos nuevos.
 *
 * El estado se lee de la suscripcion real del navegador y no de nada guardado
 * por la app: si iOS la revoca —al desinstalar la webapp, al borrar los datos
 * del sitio— la app tiene que enterarse y no quedarse diciendo que estan
 * activos cuando ya no llega nada.
 */
export default function Avisos() {
  const [activos, setActivos] = useState<boolean | null>(null)
  const [ocupado, setOcupado] = useState(false)
  const [fallo, setFallo] = useState<string | null>(null)
  const [nota, setNota] = useState<string | null>(null)

  const posible = sePuedeAvisar()
  const instalada = estaInstalada()

  useEffect(() => {
    if (!posible) {
      setActivos(false)
      return
    }
    void suscripcionActual().then((s) => setActivos(Boolean(s)))
  }, [posible])

  async function cambiar(encender: boolean) {
    setOcupado(true)
    setFallo(null)
    setNota(null)
    try {
      if (encender) await activarAvisos()
      else await desactivarAvisos()
      setActivos(encender)
    } catch (err) {
      setFallo(err instanceof Error ? err.message : 'No se pudo cambiar')
    } finally {
      setOcupado(false)
    }
  }

  async function probar() {
    setFallo(null)
    setNota(null)
    try {
      const enviados = await probarAviso()
      setNota(
        enviados > 0
          ? 'Enviado. Deberia llegarte en unos segundos.'
          : 'No hay ningun dispositivo suscrito.',
      )
    } catch (err) {
      setFallo(err instanceof Error ? err.message : 'No se pudo enviar')
    }
  }

  return (
    <div className="aviso">
      <strong>Avisos de capitulos nuevos</strong>

      {!posible ? (
        <p className="meta">
          {instalada
            ? 'Este dispositivo no admite avisos web.'
            : 'Anade Yomou a la pantalla de inicio desde Safari. En iOS los avisos solo llegan a la app instalada, no a una pestana de Safari.'}
        </p>
      ) : activos ? (
        <>
          <p>
            Activados
            <span className="meta">
              El servidor mira tu biblioteca cada cuarto de hora y te avisa cuando una serie tiene
              capitulos nuevos. Tocar el aviso abre la serie.
            </span>
          </p>
          <div className="fila-acciones">
            <button className="boton secundario" onClick={probar} disabled={ocupado}>
              Mandarme uno de prueba
            </button>
            <button className="boton secundario" onClick={() => cambiar(false)} disabled={ocupado}>
              Desactivar
            </button>
          </div>
        </>
      ) : (
        <>
          <p className="meta">
            Que el servidor te avise cuando salga un capitulo nuevo de las series que tienes en la
            biblioteca, sin tener que abrir la app a mirar.
          </p>
          <button className="boton secundario" onClick={() => cambiar(true)} disabled={ocupado}>
            {ocupado ? 'Activando…' : 'Activar avisos'}
          </button>
        </>
      )}

      {fallo && <p className="error-texto">{fallo}</p>}
      {nota && <p className="meta">{nota}</p>}
    </div>
  )
}
